// extracted by mini-css-extract-plugin
module.exports = {"icon":"Collapse_icon__3k5xh","icon-collapsed":"Collapse_icon-collapsed__fq-OM"};